/**
 * Setup a maxlength indicator for the input field.
 * @param {HTMLInputElement|HTMLTextAreaElement} $element
 */
export function setupIndicator($element) {
	if (!$element.hasAttribute('maxlength')) {
		return;
	}

	if ($element.hasAttribute('data-ams-cpd-maxlength-indicator-setup')) {
		return;
	}

	const $indicator = document.createElement('div');
	const message = $element.getAttribute('data-ams-cpd-maxlength-indicator-message') || ':characters: character/s remaining';

	$indicator.classList.add('ams-cpd-maxlength-indicator');

	$element.parentNode.insertBefore($indicator, $element.nextSibling);

	$element.addEventListener('input', () => {
		const remaining = $element.maxLength - $element.value.length;
		$indicator.textContent = message.replace(':characters:', remaining.toString());
	});

	$element.dispatchEvent(new Event('input'));
}
